export function calculatePublishPercentage(contents) {
  if (!Array.isArray(contents) || contents.length === 0) {
    return { published: 0, total: 0, percentage: 0 }
  }

  const total = contents?.length
  const published = contents?.filter(item => item.is_published).length
  const percentage = Number(((published / total) * 100).toFixed(2))

  return {
    published: Number(published),
    total: Number(total),
    percentage: Number(percentage),
  }
}

export const contentData = {
  // id: auto generated from backend
  url: "",
  remarks: "",
  is_published: false,
  //   date: auto generated from backend
}

export const getCurrentContentCount = (contents, currentPlatformSlug) => {
  return contents?.find(item => item?.slug === currentPlatformSlug) ?? null
}
